<template>
   <div class="modal-container has-text-centered">
       <div id="xButt" class="delete is-pulled-right top10" @click="cancel"></div>
         <div class=" bottom20">
           <div class="top40"><img src="@/assets/img/fourDotsLogo.png" width="18"/><div class="is-size-4 is-inline-block"><span class="left3 has-text-white"> SHARE BUNDLE</span></div></div>
        </div>

       <div v-show="!link && inView == 0">
            <div class="top10">
                Select the bundles  you want to include:
            </div>
    
            <div class="shareTree">
                 <div class="has-text-left">
                    <share-tree :listName="topBundle.listName" :children="topBundle.children" :depth="0" :id="topBundle.id"></share-tree>
                 </div>
            </div>
    
            <div class="pad10 has-text-centered top30">
                <div><b>Notes:</b></div>
                <textarea rows="2" ref="bName" type="text" class="input" placeholder="Enter notes here" v-model="notes"></textarea>
                <!-- <div class="shareNote has-text-left" contenteditable="true" v-text="notes"></div> -->
            </div>
       </div>

        <div v-show="!newGroup">
           
    
           <div v-show="inView == 0 || inView == 2" class="top20">
                <button v-show="!link" class="button is-small top20 is-coolGreen getButt" @click="send(false)">CONTINUE</button><br>
                <div v-show="link" class="is-size-6 top10"><b>Anyone with the link can view</b></div>
                <div v-show="link">
                        <div id="linkText"  class="pad10 bgDark">
                        {{generatedLink}}
                        </div>
                        
                        <div v-if="$root.app.inApp" class="is-inline-block">
                            <button  class="button top10 is-small is-coolGreen" @click="appShare"><i class="fa fa-share-square is-size-6"></i>&nbsp;<b>SHARE</b></button>
                        </div>&nbsp;&nbsp;
                        <div class="is-inline-block">
                           <button id="copyButt" ref="copyButt"  class="button top10 is-small is-coolGreen" @click="copy"><i class="far fa-clone is-size-6"></i>&nbsp;<b>COPY</b></button>
                        </div>
                </div>
           </div>
    
           <div v-show="inView == 4">
               <div>Group Members have been Notified</div>
           </div>
           
            <!-- <div class="cancelButton is-small top20" @click="cancel">Done</div> -->
            <br><br>
        </div>


        <div v-show="newGroup">
            <div><b>Create New Group</b></div>
            <div>Name:</div>
             <input type="text" class="input top5" style="width: 200px" ref="gNameInput"/>
             <div class="has-text-danger is-size-6">{{err}}</div>
             <div class="top5">Members:</div>
             <div class="has-background-grey groupConnectChooser marginAutod has-text-left pad10" id="memberList">
                 <div v-for="(item, index) in connects" :key="index" ref="groupMembers" :ci="item.id">
                     <input type="checkbox" class="checkbox"/> 
                      <span v-if="item.id_recip == true && item.meOrig">&nbsp;{{item.fName + ' ' + item.lName}}</span>
                      <span v-if="!item.meOrig">&nbsp;{{item.origF + ' ' + item.origL}}</span>
                 </div>
             </div>
             <div class="top10"><button class="button is-small is-coolGreen" @click="createGroup">Create</button>&nbsp;<button class="button is-small" @click="cancelGroup">Cancel</button></div>
             <br>
        </div>
   </div>
</template>


<script>

import ShareTree from '../components/ShareTree'
import { AZEventBus } from '../components/AZEventBus'

export default{
    props: {
        id: Number,
        branch: Array
    },

    components: {
        ShareTree
    },

    data: function(){
        return {
            topBundle: {listName: '', children: [], id: 0},
            bundleTree: [],
            blob: [],
            link: false,
            generatedLink: '',
            notes: '', 
            groups: [],
            inView: 0,
            newGroup: false,
            connects: [],
            err: ''
        }
    },

    mounted: function(){

        var self = this

        this.topBundle = this.$root.app.bundles.find((e) => {
            return e.id == this.id
        })

        this.notes = this.topBundle.pubNote

        //create a tree of ids for all bundles under topBundle
        function buildIt(b){
            var obj = {};
            obj.id = b.id;
            obj.children = [];
            obj.selected = true;

            function buildChildren(kids){
                var arr = []
                kids.forEach((e) => {
                    var temp = {
                        id: e.id,
                        children: [],
                        selected: true
                    }
                    if(e.children){
                        temp.children = buildChildren(e.children)
                    }
                    arr.push(temp)
                })
                return arr
            }
            
            if(b.children){
               obj.children = buildChildren(b.children)
            }

            self.bundleTree.push(obj)
        }

        buildIt(this.topBundle)


        function processClick(id, arr, selected){
            arr.forEach(e => {
                if(e.id == id){
                    e.selected = selected
                    return
                }
                if(e.children){
                    processClick(id, e.children, selected)
                }
            })
        }

        AZEventBus.$on('onShareTreeClicked', msg => {
           
             if(self.bundleTree[0].id == msg.id){
                event.preventDefault()
                return
            }
            processClick(msg.id, self.bundleTree, msg.selected)
        }) 

        function w(d){
            self.groups = d.r
        }

        function n(){

        }

        this.$root.app.apiClient.get('auth/account/groups', {}, w, n);
 
    },

    beforeDestroy: function(){
        AZEventBus.$off('onShareTreeClicked')
    },

    methods: {
        cancel: function(){
            this.$emit('close')
        },

        send: async function(isGroup){
            //find checked bundles and build object that contains them

    

         /*    function sleep(ms) {
                return new Promise(resolve => setTimeout(resolve, ms));
             }

            //
            if(!this.$root.app.fullLoad){
                this.$root.app.InitialDataLoad(true);

                while (!this.$root.app.fullLoad) {
                    await sleep(200);
                }       
                  
            } */

            

            let groupId = isGroup ? parseInt(this.$refs.dropdown.options[this.$refs.dropdown.selectedIndex].value) : 0

            
            if(groupId == -1 && isGroup)
                return

            if(groupId == 0){
                this.inView = 2
            } else {
                this.inView = 1
            }
            

            var self = this;

  /*           var affectedBundleIds = []

            function buildBlob(arr){
                var tempArr = [];
                arr.forEach(e => {
                    var origBundle = self.$root.app.bundles.find((i => {
                        return i.id == e.id
                    }))

                
                    var temp = {
                        id: e.id,
                        listName: origBundle.listName,
                        items: [],
                        children: [],
                        privNote: '',
                        pubNote: origBundle.pubNote
                    }

                    if(e.selected){
                        affectedBundleIds.push(origBundle.id)

                        origBundle.items.forEach(n => {
                            var card = self.$root.app.cards[n.cardsIndex];
                            var toInsert = {
                                description: card.description,
                                id: card.id,
                                img: card.img,
                                note: card.note,
                                site: card.site,
                                tags: card.tags,
                                title: card.title,
                                url: card.url,
                                p: n.p
                            }
                            temp.items.push(toInsert)
                        })
                    }

                    if(e.children){
                        temp.children = buildBlob(e.children);
                    }
                    tempArr.push(temp);
                })
                return tempArr;
            }

            let tempBlob = buildBlob(this.bundleTree) */
            

   

            //self.blob = JSON.stringify(tempBlob);

            function w(data){
                az.addRemSpinner(false, 'class', 'getButt');
                if(data.response == 'error'){
                    self.$root.app.showModalOK({message: 'There was an error processing your request, please try again or contact support'})
                } else {
                    if(data.response == 'Already Shared'){
                        self.$root.app.showModalOK({message: 'You have already shared this bundle with this group'})
                        return
                    }

                    if(groupId == 0){
                        self.generatedLink = `https://${process.env.VUE_APP_DOMAIN_NAME}/sb?s=${data.response}`
                        self.link = true
                    } else {
                        self.inView = 4
                    }

                    //
                   /*  affectedBundleIds.forEach(e => {
                        let b = self.$root.app.bundles.find(i => {
                            return i.id == e
                        })
                       
                        b.beenShared = 1;
                        b.exportAcl = groupId;
                        self.$root.app.$refs.routerView.$refs.rootBundleContainers.forEach(e => {
                            e.$forceUpdate()
                        })
                        
                    }) */
                  
                }
            }

            function n(){
                az.addRemSpinner(false, 'class', 'getButt');
                self.$root.app.showModalOK({message: 'There was an error processing your request, please try again or contact support'})
            }


            
            az.addRemSpinner(true, 'class', 'getButt');
            this.$root.app.apiClient.post('subs/data/share', {tree: this.bundleTree, groupId: groupId, note: this.notes}, w, n);
        },

        copy: function(){
            var self = this;
            let e = document.getElementById('linkText')
            e.style.backgroundColor = '#888'
            var ms = `${e.textContent.trim()}`
            az.copyToClipboard(ms);
            setTimeout(function(){ 
                e.style.backgroundColor = '#363636';
                document.getElementById('copyButt').textContent = ''
                document.getElementById('copyButt').classList.add('fas', 'fa-check')
            }, 100)
            setTimeout(function(){
                self.cancel()
            }, 700)

        },

        appShare: function(){
            let e = document.getElementById('linkText')
            var ms = `${e.textContent.trim()}`
            window.webkit.messageHandlers.myMessageName.postMessage(ms)
            this.$emit('close')
        },

        doNewGroup: function(){
            this.newGroup = true
            let self = this

            function w(d){
                az.addRemSpinner(false, 'id', 'memberList')
                
                let a = d.r.filter(e => {
                    return e.active == 1
                })

                a.sort()
                self.connects = a

            }

            function n(){
                az.addRemSpinner(false, 'id', 'memberList')

            }

            az.addRemSpinner(true, 'id', 'memberList')
            this.$root.app.apiClient.get('subs/conn/', {}, w, n)
        },

        cancelGroup: function(){
            this.err = ''
            this.newGroup = false;
        },

        createGroup: function(){

            let self = this

            let toInclude = []

            this.err = ''

            this.$refs.groupMembers.forEach(e => {
               if(e.firstChild.checked){
                   toInclude.push(parseInt(e.attributes.ci.value))
               }
            })

            let ind = this.groups.findIndex(e => {
                return e.name == self.$refs.gNameInput.value
            })

            if(ind > -1){
                this.err = 'Group must have unique name.'
                return
            }

            if(this.$refs.gNameInput.value == ''  || toInclude.length == 0 ){
                return
            }

            function w(d){
                if(d.r != 'Failed'){
                    self.groups.unshift({name: self.$refs.gNameInput.value, id: d.r})
                    self.newGroup = false
                    setTimeout(function(){
                        self.$refs.dropdown[1].selected = true
                    }, 30)
                    
                    
                }
            }

            function n(){
                
            }   

            this.$root.app.apiClient.post('subs/data/createaclgroup',{toInclude: toInclude, gName: this.$refs.gNameInput.value }, w, n)
        }
    }

}
</script>


<style scoped>
    .modal-container{
        max-width: 400px;
    }

    .title{
        margin: 0 50px 0 50px
    }
    #xButt{
        background-color: transparent !important;
        position: absolute;
        font-size: 2rem !important;
        right: 10px;
    }

  
    .delete::after{
        width: 1px;
        height: 100%
    }
     .delete::before{
        height: 1px;
        width: 100%
    }

    textarea{
        background-color: #333;
        border: none;
        border-bottom: 1px solid #f1c232;
        color: white;
        max-width: 320px;
        height: 70px
    }

    textarea::placeholder{
        color: #888
    }
</style>